import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-2" }
const _hoisted_4 = { for: "since" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field col-2" }
const _hoisted_8 = { for: "since" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "field col-2" }
const _hoisted_12 = { for: "since" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "field col-2" }
const _hoisted_16 = { class: "field col-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Panel from 'primevue/panel'
import Calendar from "primevue/calendar";

import {AxiosStatic} from "axios";
import {inject, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required, requiredIf} from "@vuelidate/validators";
import InputField from "@/components/blocks/InputField.vue";
import CompanyField from "@/components/blocks/CompanyField.vue";
import {Company} from "@/components/blocks/Types";
import FileUpload, {
  FileUploadBeforeSendEvent,
  FileUploadBeforeUploadEvent,
  FileUploadSelectEvent,
  FileUploadUploadEvent
} from "primevue/fileupload";
import moment from "moment/moment";
import Keycloak from "keycloak-js";
import {useUserStore} from "@/stores/UserStore";

// Define stores
type FormData = {
  issuer: Company | null
  recipient: Company | null
  invoiceNumber: string | null,
  issueDate: Date | null
  paymentDate: Date | null
  vatPaymentDate: Date | null
}

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateInvoiceForm',
  setup(__props) {

const userStore = useUserStore()

// Define types
const formData = reactive<FormData>({
  issuer: null,
  recipient: null,
  invoiceNumber: null,
  issueDate: null,
  paymentDate: null,
  vatPaymentDate: null
})

const submitted = ref<boolean>(false)

const rules = {
  issuer: {required},
  recipient: {required},
  invoiceNumber: {required: requiredIf( () => {
    if (formData.issuer == null) return true;
    if (formData.issuer.id != userStore.userDetail.company.id) return true;
    return false
    })},
  issueDate: {required},
  paymentDate: {required},
  vatPaymentDate: {required}
}

// Inject dependencies
const axios = inject<AxiosStatic>('axios')
const keycloak = inject<Keycloak>("keycloak")

//npm Define used properties
const router = useRouter()
const v$ = useVuelidate(rules, formData)
const fileUpload = ref<FileUpload>()

let fileName: (string | null) = null

// Define functions
function fileSelected(event: FileUploadSelectEvent) {
  if (event.files.length > 0) {
    fileName = event.files[0].name
  } else {
    fileName = null
  }
}

function uploadDone(response: FileUploadUploadEvent) {
  const result = JSON.parse(response.xhr.response)
  if (result.success) {
    router.push({
      name: "invoiceDetail",
      params: {
        number: result.data.id
      }
    })
  } else {
    console.error('Upload invoice failed!', response.message)
  }
}

function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    fileUpload.value.upload()
    // saveRequisition()
  } else {
    console.error('Form is not valid!')
  }
}

function beforeSendHandler(event: FileUploadBeforeSendEvent) {
  event.xhr.setRequestHeader('Authorization', 'Bearer ' + keycloak?.token)
}

function beforeUploadHandler(event: FileUploadBeforeUploadEvent) {
  // event.xhr.open()
  event.formData.set("issuerID", (formData?.issuer?.id?.toString() as string))
  event.formData.set("recipientID", (formData?.recipient?.id?.toString() as string))
  if (formData.invoiceNumber != null && formData.invoiceNumber.length > 0) {
    event.formData.set("invoiceNumber", formData.invoiceNumber as string)
  }
  event.formData.set("issueDate", moment(formData.issueDate).format("YYYY-MM-DD"))
  event.formData.set("paymentDate", moment(formData.paymentDate).format("YYYY-MM-DD"))
  event.formData.set("vatPaymentDate", moment(formData.vatPaymentDate).format("YYYY-MM-DD"))

  if (fileName != null) {
    event.formData.set("fileName", fileName)
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Add invoice",
    class: "mt-2 mb-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CompanyField, {
              id: "issuer",
              class: "col-2",
              modelValue: _unref(v$).issuer.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).issuer.$model) = $event)),
              vualidate: _unref(v$).issuer,
              submitted: submitted.value,
              label: _ctx.$t('issuer')
            }, null, 8, ["modelValue", "vualidate", "submitted", "label"]),
            _createVNode(CompanyField, {
              id: "recipient",
              class: "col-2",
              modelValue: _unref(v$).recipient.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).recipient.$model) = $event)),
              vualidate: _unref(v$).recipient,
              submitted: submitted.value,
              label: _ctx.$t('recipient')
            }, null, 8, ["modelValue", "vualidate", "submitted", "label"]),
            _createVNode(InputField, {
              id: "invoiceNumber",
              class: "field col-2",
              label: _ctx.$t('invoice-number'),
              vualidate: _unref(v$).invoiceNumber,
              submitted: submitted.value,
              modelValue: _unref(v$).invoiceNumber.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).invoiceNumber.$model) = $event))
            }, null, 8, ["label", "vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('issue-date')) + " ", 1),
                (_unref(v$).issueDate.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "since",
                class: _normalizeClass({'p-invalid':_unref(v$).issueDate.$invalid && submitted.value}),
                modelValue: _unref(v$).issueDate.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).issueDate.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).issueDate.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).issueDate.required.$message.replace('Value', 'Issue date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('vat-payment-date')) + " ", 1),
                (_unref(v$).vatPaymentDate.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "since",
                class: _normalizeClass({'p-invalid':_unref(v$).vatPaymentDate.$invalid && submitted.value}),
                modelValue: _unref(v$).vatPaymentDate.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).vatPaymentDate.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).vatPaymentDate.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_unref(v$).vatPaymentDate.required.$message.replace('Value', 'Vat payment date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.$t('payment-date')) + " ", 1),
                (_unref(v$).paymentDate.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "since",
                class: _normalizeClass({'p-invalid':_unref(v$).paymentDate.$invalid && submitted.value}),
                modelValue: _unref(v$).paymentDate.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).paymentDate.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).paymentDate.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_unref(v$).paymentDate.required.$message.replace('Value', 'Vat payment date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(FileUpload), {
                name: "file",
                ref_key: "fileUpload",
                ref: fileUpload,
                mode: "basic",
                class: "p-button-lg",
                showUploadButton: false,
                showCancelButton: false,
                multiple: false,
                url: "/invoice/upload2",
                onUpload: uploadDone,
                onSelect: fileSelected,
                onBeforeSend: beforeSendHandler,
                onBeforeUpload: beforeUploadHandler
              }, null, 512)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(Button), {
                type: "submit",
                label: _ctx.$t('add')
              }, null, 8, ["label"])
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})